<template>
    <div class="index" style="margin: 30px 15%; ">
      <div class="x-list">
        <div class="x-list-item">
          <div class="x-list-item-label">
            视频标题
          </div>
          <div class="x-list-item-input-group V-code-input">
            <input placeholder-class="fc-BCBCBC" v-model="title" type="text" maxlength="11" placeholder="请输入视频标题" />
          </div>
        </div>
        <div class="x-list-item">
          <div class="x-list-item-label">
            视频备注
          </div>
          <div class="x-list-item-input-group">
            <input placeholder-class="fc-BCBCBC" type="text" v-model="notes" placeholder="请输入视频备注" />
          </div>
        </div>
        <div class="x-list-item">
          <div class="x-list-item-label">
            抖音发布标题  <span class="fc-999">不同步抖音可不填</span>
          </div>
          <div class="x-list-item-input-group">
            <input placeholder-class="fc-BCBCBC" type="text" v-model="dyTitle" placeholder="请输入抖音发布标题" />
          </div>
        </div>
      </div>
      <div class="x-list">
        <div class="x-list-item">
          <div class="x-list-item-label">
            水印设置 <span class="fc-999">不超过7个字，可不添加</span>
          </div>
          <div class="x-list-item-input-group">
            <input placeholder-class="fc-BCBCBC" type="text" maxlength="7" v-model="overText" placeholder="请填写水印内容" />
          </div>
        </div>
        <div class="x-list-item">
          <div class="x-list-item-label">
            抖音发布时间 <span class="fc-999">视频发布至抖音时间,不同步抖音可不填写</span>
          </div>
          <div class="x-list-item-input-group" @click="shopChooseDate()">
            <input   disabled placeholder-class="fc-BCBCBC" v-model="chooseDate" placeholder="请选择发布时间" />
          </div>
        </div>
        <!-- <div class="x-list-item">
              <div class="x-list-item-label">
                  所属平台
              </div>
              <div class="x-list-item-input-group">
                  <input placeholder-class="fc-BCBCBC" type="text" data-tag="storeGroupId" bindinput="inputValue"
                      placeholder="请填写邀请您入驻的平台ID；没有，可不写" />
              </div>
          </div> -->
        <div class="x-list-item">
          <div class="x-list-item-label">
            <span>封面上传</span>
            <span class="fc-999">保证封面可显示</span>
          </div>
          <div class="x-list-item-input-group">
            <div class="uploadArea">
              <div class="uploadImg" v-if="businessImg != null">
                <img style="height:100%" :src="businessImg" mode="aspectFill" />
                <div class="delete-btn" @click="deleteBusinessImg" v-if="businessImg != null"></div>
              </div>
              <input v-if="businessImg == null" style="position: absolute;opacity: 0;z-index: 10;" class="uploadImg upload-img-btn" @change="chooseBusinessImg" type="file" accept="image/*" multiple>
              <div class="uploadImg upload-img-btn" v-if="businessImg == null">
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="x-list-item-label">
            <span>视频上传</span>
          </div>
          <div class="x-list-item-input-group">
            <div class="uploadArea">
              <div class="uploadImg" v-if="businessVideo != null">
                <img style="height:100%" src="/img/play.png" mode="aspectFill" />
                <div class="delete-btn" @click="deleteBusinessVideo" v-if="businessVideo != null"></div>
              </div>
              <input v-if="businessVideo == null" style="position: absolute;opacity: 0;z-index: 10;" class="uploadImg upload-img-btn" @change="chooseBusinessVideo" type="file" accept="video/*" multiple>
              <div class="uploadImg upload-img-btn" v-if="businessVideo == null">
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="flex flex-direction padding"  style="padding-top:0px;width: 50%;left: 25%;" bindtap="commitPay">
            <button class="cu-btn bg-blue radius" @click="payByCard">确认创建</button>
          </div>
          <div class="flex flex-direction padding"  style="padding-top:0px;width: 50%;left: 25%;" bindtap="commitPay">
            <button class="cu-btn bg-blue radius" @click="payByCard">创建并同步到抖音</button>
          </div>
        </div>
      </div>
      <div class="modal" v-if="showLoadImg">
        <van-loading color="white" style="top:46%" size="24px" vertical type="spinner">图片上传中...</van-loading>
      </div>
      <div class="modal" v-if="showVideoLoadImg">
        <van-loading color="white" style="top:46%" size="24px" vertical type="spinner">视频上传中...</van-loading>
      </div>
      <van-datetime-picker type="datetime" title="预约时间（年月日）" class="picker-c2" style="width: 80% !important;margin-left:10% !important" :value="nowDate" v-if="showDate" @cancel="showDate = false"  @confirm="onTimeChange" />
    </div>
  </template>
  <script>
//   import wx from 'weixin-js-sdk'
//   import areaData from '../../utils/area.js'
  var miao = 59
  export default {
    name: 'add',
    data () {
      return {
        requestHeadUrl: 'https://zhenqing.kequbang.com',
        // requestHeadUrl: 'http://localhost:8122',
        showModal: true, // 是否显示modal
        showModal2: false, // 支付弹窗是否显示
        winHeight: null, // 页面高度
        VCode: '', // 验证码
        mobileNo: '',
        mobileCode: '',
        checkVCode: false, // 校验验证码
        industry: '请选择所属行业', // 所属行业 默认/选中值
        branchs: ['一号店', '二号店', '三号店'], // 所属行业列表
        storeImgs: [], // 上传门店照片的数据
        storeGroupName: '',
        storeRegisterPriceInfo: {},
        storeGroupList: [],
        storeIndustryList: [],
        storeGroupNameList: [],
        storeIndustryNameList: [],
        isSendMobile: true,
        miaoShow: '获取验证码',
        businessImg: null, // 'http://file.images.kequbang.com/goods/EF3E6F0E4860F2EC15522DF5528689C4.jpg'
        businessVideo: null,
        storeLocationAddr: '',
        storeName: '',
        storeAccountPwd: '',
        storeAccountConfirmPwd: '',
        storeLeadingName: '',
        storeTelephone: '',
        storeDesc: '',
        shareholderId: null,
        region: [],
        storeOneImg: null,
        storeTwoImg: null,
        storeThreeImg: null,
        payStyle: 'wechart', // 付款方式
        postData: {
          areaNo: '',
          areaName: '',
          address: '',
          province: '',
          city: '',
          district: ''
        },
        showPicker: false,
        couponSelected: '请选择所属行业',
        showHy: false,
        hyName: '',
        storeIndustryId: '',
        activationCode: '', // 激活码
        showLoadImg: false,
        appName: '',
        showDate: false,
        chooseDate: '',
        nowDate:new Date(),
        showVideoLoadImg: false,
        title: '',
        dyTitle: '',
        notes: '',
        overText: '',
      }
    },
    created () {
      const thisObj = this
      thisObj.onLoad()
    },
    methods: {
      onLoad: function () {
      },
      onConfirm (picker, value, index) {
        // console.log(value) // 下标
        // console.log(picker) // 值
        var that = this
        this.showHy = false
        this.hyName = picker
        for (const i in that.storeIndustryList) {
          if (that.storeIndustryList[i].storeIndustryName === picker) {
            that.storeIndustryId = that.storeIndustryList[i].storeIndustryId
            break
          }
        }
      },
      onCancel () {
        this.showHy = false
      },
      showHyList () {
        this.showHy = true
      },
      shopChooseDate() {
        this.showDate = true
        },
    onTimeChange(date) {
        console.log(date)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
        var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
        var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
        var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
        var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f
        this.chooseDate = formatdate
        this.showDate = false
     },
      showPayStyleModel: function () {
        this.showModal2 = true
      },
      closeModule () {
        this.showModal2 = false
      },
      confirmArea (e) {
        const thisObj = this
        thisObj.postData.province = e[0].name
        thisObj.postData.city = e[1].name
        thisObj.postData.district = e[2].name
        thisObj.postData.areaNo = e[2].code
        thisObj.postData.areaName = e[0].name + ',' + e[1].name + ',' + e[2].name
        thisObj.showPicker = false
        thisObj.storeLocationAddr = ''
        thisObj.atuoGetLocation()
      },
      atuoGetLocation () {
        var that = this
        if (that.postData.areaName !== '') {
          let addressData = that.postData.areaName + that.storeLocationAddr
          var url = 'https://apis.map.qq.com/ws/geocoder/v1/'
          that.$jsonp(url, {
            key: '5JYBZ-A3B36-K6JSW-EKX7S-MT22V-ATF4U',
            address: addressData,
            output: 'jsonp'
          }).then(res => {
          //   console.log(res.result.location)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      changePayStyle: function (type) {
        const thisObj = this
        thisObj.payStyle = type
      },
      confirmMenu: function () {
        const thisObj = this
        thisObj.showModal = false
      },
      cancleMenu () {
      //   this.$router.go(-1)
        wx.miniProgram.switchTab({
          url: '/pages/user/user'
        })
        // wx.miniProgram.navigateBack({ delta: 1 })
      },
      getBindCode: function () {
        var that = this
        var mobileNo = that.mobileNo
        var isSendMobile = that.isSendMobile
        if (mobileNo.length === 0) {
          that.$util.requetServerError('亲,请输入手机号码')
        } else if (mobileNo.length < 11) {
          that.$util.requetServerError('亲,你输入的手机号码长度少于11位')
        } else if (that.miaoShow === '获取验证码') {
          if (isSendMobile) {
            that.$api.post(that.requestUrl + '/store/register/mobileCode/get?fromDevice=h5&mobileNo=' + mobileNo, { }).then(result => {
              if (result.success) {
                that.$util.showSuccessMsg('发送验证码成功')
                that.isSendMobile = false
                that.setTimeOutSendMobileCode()
              }
            })
          }
        }
      },
      setTimeOutSendMobileCode: function () {
        var that = this
        var interval = setInterval(function () {
          that.isSendMobile = false
          that.miaoShow = '' + miao + '秒重新获取'
          if (miao === 0) {
            miao = 59
            clearInterval(interval)
            that.isSendMobile = true
            that.miaoShow = '获取验证码'
          }
          miao--
        }, 1000)
      },
      /* 上传图片 */
      chooseStoreImg: function (e) {
        const that = this
        that.showLoadImg = true
        var storeImgs = that.storeImgs
        if (storeImgs.length <= 3) {
          var files = e.target.files[0]
          var formdata1 = new FormData()
          formdata1.append('uploadFile', files)
          that.$api.post(that.requestUrl + '/auth/alliance/store/upload/file/image?fromDevice=h5', formdata1, { headers: {
            'Content-Type': 'multipart/form-data'
          } }).then(result => {
            if (result.success) {
              that.storeImgs.push(result.resultData)
              that.showLoadImg = false
              // console.log(result.resultData)
            }
          })
        } else {
        }
      },
  
      /* 上传图片 */
      chooseBusinessImg: function (e) {
        const that = this
        var files = e.target.files[0]
        if (files.size/1024 > 12000) {
            that.$util.requetServerError('图片大小不得大于120kb！')
            return
        }   
        that.showLoadImg = true
        console.log(files)
        var formdata1 = new FormData()
        formdata1.append('uploadFile', files)
        that.$api.post(that.requestUrl + '/auth/alliance/store/upload/file/image?fromDevice=h5', formdata1, { headers: {
          'Content-Type': 'multipart/form-data'
        } }).then(result => {
          if (result.success) {
            that.businessImg = result.resultData
            that.showLoadImg = false
          //   console.log(result.resultData)
          }
        })
      },
      chooseBusinessVideo: function (e) {
        const that = this
        var files = e.target.files[0]
        if (files.size/1024/1024 > 10) {
            that.$util.requetServerError('视频大小不得大于10M！')
            return
        }
        that.showVideoLoadImg = true
        console.log(files)
        var formdata1 = new FormData()
        formdata1.append('uploadFile', files)
        that.$api.post(that.requestUrl + '/auth/alliance/store/upload/file/image?fromDevice=h5', formdata1, { headers: {
          'Content-Type': 'multipart/form-data'
        } }).then(result => {
          if (result.success) {
            that.businessVideo = result.resultData
            that.showVideoLoadImg = false
          //   console.log(result.resultData)
          }
        })
      },
      // 删除营业执照图片
      deleteBusinessImg: function (e) {
        this.businessImg = null
      },
      deleteBusinessVideo: function (e) {
        this.businessVideo = null
      },
      /* 删除图片 */
      deleteStoreImg: function (index) {
        this.storeImgs.splice(index, 1)
      },
      // 小程序和公众号跳转不同页面
      payByCard: function () {
        var that = this
        var url = that.requestHeadUrl + '/dyExamine/editInfo'
        var params = {
          'title': that.title,
          'dyTitle': that.dyTitle,
          'notes': that.notes,
          'overText': that.overText,
          'img': that.businessImg,
          'video': that.businessVideo,
          'pushTime': that.chooseDate,
        }
        that.$api.post(url, params).then(result => {
          // console.log(result)
          if (result) {
            console.log('111')
            that.$router.push({
                path: '/videoList',
            })
            // wx.miniProgram.navigateBack({ delta: 1 })
            // this.navigateToMiniProgram(JSON.stringify(payParam))
          } else {
            that.$util.showSuccessMsg(result)
          }
        }).catch(function (error) {
          that.$util.requetServerError(error)
        })
      }
    }
  }
  </script>
  <style lang="css" scoped>
  .addressList {
    height: 100%;
    background-color: #fafafa;
  }
  .fc-F74044 {
    color: #f74044;
  }
  .TimUi-form-list {
    margin: 20px 0 0 0;
  }
  
  .TimUi-form-list-item .TimUi-form-list-label {
    font-size: 30px;
    font-weight: 400;
    color: rgba(85, 85, 85, 1);
  }
  
  .TimUi-form-list-item .TimUi-form-list-label.fc-33474E {
    color: #33474e;
  }
  
  .TimUi-form-list-item .TimUi-form-list-inner {
    padding-left: 56px;
  }
  
  .TimUi-form-list-item .TimUi-form-list-inner p {
    font-size: 32px;
    color: rgba(0, 0, 51, 1);
  }
  
  .TimUi-form-list-item .TimUi-form-list-inner .fc-999 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
  }
  
  .TimUi-form-list-item .TimUi-form-list-inner input,
  .TimUi-form-list-item .TimUi-form-list-inner textarea {
    color: rgba(0, 0, 51, 1);
  }
  
  .TimUi-form-list-item.autoHeight {
    height: 180px;
  }
  
  .TimUi-form-list-item.autoHeight .TimUi-form-list-label {
    padding: 25px 0 0 0;
  }
  .TimUi-form-list .TimUi-form-list-item .van-icon {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 0 18px 0 0;
    font-size: 24px;
    transform: translate(0, -50%);
  }
  
  .TimUi-form-list .TimUi-form-list-item .van-icon-passed:before {
    content: "";
    width: 23px;
    height: 23px;
    border: 1px solid #eee;
    border-radius: 50%;
  }
  
  .TimUi-form-list-item.autoHeight .TimUi-form-list-inner,
  .TimUi-form-list-item.autoHeight .TimUi-form-list-inner textarea {
    width: 100%;
    height: 100%;
  }
  
  .TimUi-form-list-item.autoHeight .TimUi-form-list-inner textarea {
    padding: 25px 0;
    font-size: 32px;
    box-sizing: border-box;
  }
  
  .TimUi-submit-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  
  .TimUi-submit-bar .TimUi-btn {
    width: 100%;
    line-height: 100px;
    margin: 0;
    padding: 0;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  page {
    overflow-x: hidden;
    background-color: #f8fbff;
  }
  
  .bgC-4274EE {
    background-color: #4274ee;
  }
  
  .x-list {
    margin: -18px 0 0 0;
    padding: 0 0 20px 0;
    background-color: #fff;
  }
  
  .x-list:first-child {
    margin: 0;
  }
  
  .x-list-item {
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    min-height: 130px;
    height: initial;
    padding: 43px 30px 0 30px;
  }
  
  .x-list-item:after {
    left: 30px;
    right: 30px;
  }
  
  .x-list-item .x-list-item-label {
    font-size: 30px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(81, 93, 241, 1);
    text-align: left;
    margin-left: 2px;
  }
  
  .x-list-item .x-list-item-label .fc-999 {
    margin: 0 0 0 18px;
    font-size: 20px;
    color: #999;
    -webkit-transform-origin-x: 0;
    transform: scale(0.65);
  }
  
  .x-list-item .x-list-item-input-group {
    width: 100%;
  }
  
  .x-list-item .x-list-item-input-group input,
  .x-list-item .x-list-item-input-group textarea,
  .x-list-item .x-list-item-input-group .picker {
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    min-height: 70px;
    line-height: 1.1;
    color: #606060;
    border: 0px;
  }
  
  .x-list-item .x-list-item-input-group .fc-BCBCBC,
  .x-list-item .x-list-item-input-group .picker.fc-BCBCBC {
    color: #bcbcbc;
  }
  
  .x-list-item .x-list-item-input-group textarea {
    height: 99px;
    padding: 20px 0;
  }
  
  .x-list-item.justify-content-between {
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
    min-height: 115px;
    padding-top: 0;
  }
  
  .justify-content-between.x-list-item:before,
  .justify-content-between.x-list-item:after {
    content: "";
    position: absolute;
    top: 0;
    left: 30px;
    right: 30px;
    border: none;
    border-bottom: 1px solid #dfdfdf;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }
  
  .justify-content-between.x-list-item:after {
    top: initial;
    bottom: 0;
  }
  
  .x-list-item.justify-content-between .x-list-item-label {
    min-width: auto;
  }
  
  .V-code-input .x-btn {
    z-index: 12;
    position: absolute;
    right: 15px;
    top: 50%;
    width: 2.33333rem;
    height: 0.96667rem;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    transform: translate(0, -50%);
  }
  
  .showIcon icon {
    z-index: 10;
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translate(0, -50%);
  }
  
  .location-input-group image {
    z-index: 10;
    position: absolute;
    right: 13px;
    top: 50%;
    width: 32px;
    height: 30px;
    transform: translate(0, -50%);
  }
  
  .select-input-group image {
    z-index: 10;
    position: absolute;
    right: 11px;
    top: 50%;
    width: 23px;
    height: 13px;
    transform: translate(0, -50%);
  }
  
  .uploadArea {
    display: -webkit-flex;
    display: flex;
  }
  
  .uploadArea .uploadImg {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-flex-direction: column;
    flex-direction: column;
    max-width: 100%;
    min-width: 100%;
    width: 100%;
    height: 360px;
    margin: 28px 0;
    text-align: center;
  }
  
  .uploadArea image {
    max-width: 100%;
    min-width: 100%;
    width: 100%;
    height: 100%;
  }
  
  .uploadArea .uploadImg.upload-img-btn {
    max-width: 100%;
    width: 100%;
    height: 360px;
    border: 4px dashed #999;
    border-radius: 10px;
  }
  
  .uploadArea .uploadImg.upload-img-btn:before,
  .uploadArea .uploadImg.upload-img-btn:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: #999;
    transform: translate(-50%, -50%);
  }
  
  .uploadArea .uploadImg.upload-img-btn:before {
    width: 80px;
    height: 6px;
  }
  
  .uploadArea .uploadImg.upload-img-btn:after {
    width: 6px;
    height: 80px;
  }
  
  .uploadArea.upload-group {
    justify-content: space-between;
  }
  
  .uploadArea.upload-group .uploadImg,
  .uploadArea.upload-group .upload-img-btn {
    max-width: 207px;
    min-width: 207px;
    width: 207px;
    height: 187px;
  }
  
  .delete-btn {
    position: absolute;
    right: -15px;
    top: -15px;
    width: 30px;
    height: 30px;
    background: url("data:image/png;base64,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");
    background-size: 100% 100%;
  }
  
  .dw {
    position: absolute;
    font-size: 40px;
    right: 20px;
    top: 20px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  
  .btn-submit-group {
    padding: 0 0 205px 0;
  }
  
  .btn-submit-group .x-btn {
    width: 640px;
    height: 100px;
    line-height: 100px;
    margin: 0 auto;
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    color: #fff;
    border-radius: 50px;
  }
  
  /* 模态样式 */
  .modal {
    z-index: 12;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  /* .cuIcon-close::before {
    content: "\e646";
  } */
  .modal-content {
    position: fixed;
    top: 50%;
    left: 33px;
    right: 33px;
    padding: 0 55px;
    background: #fff;
    transform: translate(0, -50%);
  }
  
  .modal-header {
    width: 100%;
    height: 150px;
    line-height: 150px;
    text-align: center;
    font-size: 39px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(79, 79, 79, 1);
  }
  
  .modal-inner {
    overflow: hidden;
    overflow-y: auto;
    min-height: 300px;
    max-height: 600px;
    line-height: 22px;
    font-size: 28px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(92, 92, 92, 1);
    text-align: justify;
    text-align-last: justify;
  }
  
  .modal-inner > div {
    margin-bottom: 20px;
    line-height: 48px;
  }
  
  .moal-radio-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    margin: 0;
  }
  
  .moal-radio-group:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border: none;
    border-bottom: 1px solid #e9eaec;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }
  
  .moal-radio-group .radio {
    width: 40px;
    height: 40px;
    border: 2px solid #dddddd;
    border-radius: 200px;
  }
  
  .moal-radio-group .radio.active:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 24px;
    height: 24px;
    background: #515df1;
    border-radius: 200px;
    transform: translate(-50%, -50%);
  }
  
  .modal-footer {
    padding: 119px 0 27px 0;
    text-align: center;
  }
  
  .modal-footer .tips {
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: rgba(68, 68, 68, 1);
  }
  
  .modal-footer .x-btn {
    width: 544px;
    height: 81px;
    line-height: 81px;
    margin: 32px auto 18px auto;
    text-align: center;
    font-size: 29px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 40px;
  }
  
  .modal-footer .fc-4274EE {
    font-size: 26px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #4274ee;
  }
  
  .down-text {
    z-index: 10;
    position: absolute;
    right: 13px;
    top: 50%;
    width: 32px;
    height: 30px;
    transform: translate(0, -50%);
  }
  .van-overflow-hidden {
    overflow-y: auto !important;
  }
  .hy-sel {
    width: 100%;
    border: 0px;
    height: 1rem;
  }
  .bg-blue {
    background-color: rgb(0, 129, 255);
    font-size: 0.35rem;
    width: 90%;
    color: white;
    font-weight: 300;
    height: 1.1rem;
    margin-bottom: 0.5rem;
    border-radius: 0.1rem;
  }
  .cu-btn.lg {
    font-size: 32rpx;
    height: 80rpx;
  }
  .bgC-515DF1 {
    background-color: #515DF1;
  }
  .van-loading__text{
      color: #fff;
  }
  .picker-c2 {
  position: fixed;
  min-width: 42% !important;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
  </style>
  